import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({
    name: 'moment'
})
export class MomentPipe implements PipeTransform {

    transform(value: Date, format?: string): string {
        if (!value) return '';
        if (!format) format = 'YYYYMMDD';
        return moment(value).format(format);
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/pipes/moment.pipe.ts